__turbopack_context__.v({
  "badge-img": "PkXyuq_badge-img",
  "button-link": "PkXyuq_button-link",
  "card": "PkXyuq_card",
  "container": "PkXyuq_container",
  "contianer-img": "PkXyuq_contianer-img",
});
